import { Pipe, PipeTransform } from '@angular/core';
import { DROPDOWN_SORT } from '../dataModels/constants';
/**
 * Pipe to sort dropdown
 */
@Pipe({
  name: 'dropdownSort'
})
export class DropdownSortPipe implements PipeTransform {
  /**
   * Sorting the list
   * @param value dropdown list
   * @param args sortType
   */
  transform(value: Array<any>, ...args: any[]): any {
    switch (args[0]) {
      /**
       * Sorting the dropdown by description property in ascending order
       */
      case DROPDOWN_SORT.DESCR: {
        return value.sort((a, b) => {
          const d1 = a.descr;
          const d2 = b.descr;
          return d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
        });

        break;
      }
      /**
       * Sorting the dropdown by object name and push UNKNOWN to last
       */
      case DROPDOWN_SORT.UNKNOWN_AT_END: {
        let objName;

        if (value && value.length > 0) {
          if (value[0].countyCode) {
            objName = 'countyName';
          } else if (value[0].municipalityCode) {
            objName = 'municipalityName';
          }
        }

        if (objName) {
          value = value.sort((a, b) => {
            const d1 = a[objName];
            const d2 = b[objName];
            return d1 < d2 ? -1 : d1 > d2 ? 1 : 0;
          });

          const items = value.filter(item => {
            return item[objName] !== 'UNKNOWN';
          });

          const unknownItem = value.find(item => item[objName] === 'UNKNOWN');
          if (unknownItem) {
            items.push(unknownItem);
          }

          return items;
        }

        break;
      } // end of DROPDOWN_SORT.UNKNOWN_AT_END

      /**
       * Sorting the dropdown by intfcEntityName in ascending order
       */
      case DROPDOWN_SORT.INTFC_ENTITY_NAME: {
        if (value && value.length > 0) {
          return value.sort((a, b) => {
            const d1 = a.intfcEntity.intfcEntityName;
            const d2 = b.intfcEntity.intfcEntityName;
            return d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
          });
        }
        break;
      }

      /**
       * Sorting the dropdown by Insurance Provider Name
       */
      case DROPDOWN_SORT.INSURANCE_NAME: {
        return value.sort((a, b) => {
          const d1 = a.insuranceProviderName;
          const d2 = b.insuranceProviderName;
          return d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
        });

        break;
      }
      case DROPDOWN_SORT.DISPLAY_NAME: {
        return value.sort((a, b) => {
          const d1 = a.displayName;
          const d2 = b.displayName;
          return d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
        });

        break;
      }

      /**
       * Default is sorting the dropdown by displayOrder
       */
      default: {
        if (value && value.length > 0 && value[0].displayOrder) {
          return value.sort((a, b) => {
            const d1 = +a.displayOrder;
            const d2 = +b.displayOrder;
            return d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
          });
        } else {
          return value;
        }
        break;
      }
    }
  }
}
